<script>
  import { useNavigate } from "svelte-navigator";
  import { useUrlParams } from "@stores/urlStore.js";
  import { ROUTES } from "@utils/routes.js";
  //// imports
  import Header from "lib/components/Header.svelte";
  import Button from "lib/components/Button.svelte";

  import ApplicationMapping from "./mappingAssistant/ApplicationMapping.svelte";
  import ActivityMapping from "./mappingAssistant/ActivityMapping.svelte";
  import UnmappedMapper from "./mappingAssistant/UnmappedMapper.svelte";
  import MainCard from "lib/components/MainCard.svelte";
  import ParentChild32 from "carbon-icons-svelte/lib/ParentChild32";
  //// temp

  const navigate = useNavigate();
  let nameOfCurrentActivity = "Application Name Mapping";

  const urlParams = useUrlParams();

  $: ({ analysisid, view } = $urlParams);
  $$restProps;
</script>

{#if view == "main"}
  <Header section="Mapping Assistant" breadcrumb={nameOfCurrentActivity}>
    <Button
      text={"Back"}
      on:click={() => {
        navigate(ROUTES.dam.root);
      }}
      iconLeft={true}
      icon="arrow_left"
      variant="secondary"
    />
  </Header>
  <div class="mainview">
    <div>
      <MainCard
        cardlogo={ParentChild32}
        cardtitle="Application Mapping"
        cardtext="Map your Application names, classify by usefulness and add missing application icons."
        cardlink={ROUTES.dam.appnamemapping}
      />
      <MainCard
        cardlogo={ParentChild32}
        cardtitle="Activity Mapping"
        cardtext="Define your Activities. Map Windowtitles to Acitivities and define Start and End events."
        cardlink={`${ROUTES.dam.mappingAssistant}?view=activitymapping&analysisid=${analysisid}`}
      />
      <MainCard
        cardlogo={ParentChild32}
        cardtitle="Unmapped Actions"
        cardtext="Find Windowtitles and Interactions that are yet unmapped and map them to your activities."
        cardlink={`${ROUTES.dam.mappingAssistant}?view=unmappedactivities&analysisid=${analysisid}`}
      />
    </div>
  </div>
{:else}
  {#if view == "applicationmapping"}
    <ApplicationMapping></ApplicationMapping>
  {/if}
  {#if view == "activitymapping"}
    <ActivityMapping {analysisid}></ActivityMapping>
  {/if}
  {#if view == "unmappedactivities"}
    <UnmappedMapper {analysisid}></UnmappedMapper>
  {/if}
{/if}

<style>
  .mainview {
    display: flex;
    height: 100%;
    width: 100%;
    padding-top: 1rem;
    padding-left: 1rem;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

</style>
